const tabButtons = document.querySelectorAll('.tab-button');
const tabPanels = document.querySelectorAll('.tab-panel');

// Add click event to each tab button
tabButtons.forEach(button => {
    button.addEventListener('click', () => {
        // Get the target tab id
        const targetTab = button.getAttribute('data-tab');

        // Remove active class from all buttons and panels
        tabButtons.forEach(btn => {
            btn.classList.remove('active');
            btn.setAttribute('aria-selected', 'false');
        });
        tabPanels.forEach(panel => {
            panel.classList.remove('active');
        });

        // Add active class to clicked button and corresponding panel
        button.classList.add('active');
        button.setAttribute('aria-selected', 'true');
        document.getElementById(targetTab).classList.add('active');
    });
});

// Optional: Add keyboard navigation (arrow keys)
tabButtons.forEach((button, index) => {
    button.addEventListener('keydown', (e) => {
        let newIndex;
        
        if (e.key === 'ArrowRight') {
            newIndex = (index + 1) % tabButtons.length;
            tabButtons[newIndex].focus();
            tabButtons[newIndex].click();
        } else if (e.key === 'ArrowLeft') {
            newIndex = (index - 1 + tabButtons.length) % tabButtons.length;
            tabButtons[newIndex].focus();
            tabButtons[newIndex].click();
        }
    });
});